import React from 'react';
import { Wine, Coffee, Beer, Droplets } from 'lucide-react';
import { beverages } from '../data/mock';

const BeverageSection = () => {
  const getIcon = (name) => {
    if (name.toLowerCase().includes('pivo') || name.toLowerCase().includes('beer')) {
      return <Beer className="w-6 h-6" />;
    }
    if (name.toLowerCase().includes('káva') || name.toLowerCase().includes('coffee')) {
      return <Coffee className="w-6 h-6" />;
    }
    if (name.toLowerCase().includes('prosecco') || name.toLowerCase().includes('wine')) {
      return <Wine className="w-6 h-6" />;
    }
    return <Droplets className="w-6 h-6" />;
  };
  
  return (
    <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Nápojové menu
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Široký výběr nápojů z mobilních barů a výčepů
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {beverages.map((beverage) => (
              <div
                key={beverage.id}
                className="group bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl hover:border-cyan-200 transition-all duration-300"
              >
                <div className="flex items-start space-x-4">
                  <div className={`rounded-xl p-3 ${beverage.alcoholic ? 'bg-amber-100 text-amber-600' : 'bg-cyan-100 text-cyan-600'} group-hover:scale-110 transition-transform duration-300`}>
                    {getIcon(beverage.name)}
                  </div>
                  <div className="flex-1">
                    <h4 className="text-lg font-bold text-gray-900 mb-1">
                      {beverage.name}
                    </h4>
                    <p className="text-sm text-gray-600 mb-3">
                      {beverage.description}
                    </p>
                    <div className="flex items-center justify-between">
                      <div className="text-xs text-gray-500">
                        {beverage.volume}
                      </div>
                      {beverage.alcoholic && (
                        <div className="bg-amber-50 text-amber-700 px-3 py-1 rounded-full text-xs font-medium">
                          18+
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BeverageSection;
